import { CoreButton } from '@komodo-design-system/komodo-components-react';
import React from 'react';
import PropTypes from 'prop-types';
import './LinkButton.scss';

const LinkButton = ({ label, onClickHandler }) => {
  return (
    <span className='link-button'>
      <CoreButton
        label={label}
        type="button"
        variant="outline"
        size="large"
        noradius="none"
        onClick={onClickHandler}></CoreButton>
    </span>
  );
};
LinkButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func
};

export default LinkButton;
